<template>
  <div class="animated fadeIn" id="list-decomptes"> 
    <transition name="fade">
      <b-card no-body>
        <div slot="header">
          <i class="fa fa-search mr-2"></i>
          <strong>Recherche</strong>
          <div class="card-header-actions">
            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
              <span class="when-opened">
                <i class="icon-arrow-down"></i>
              </span>
              <span class="when-closed">
                <i class="icon-arrow-up"></i>
              </span>
            </b-link>
          </div>
        </div>
        <b-collapse id="collapse1" visible>
          <b-card-body>
            <b-card>
              <b-form v-on:submit.prevent="search">
                <b-row>
                  <b-col sm="4">
                    <b-form-group >
                      <label for="type_decompte"><strong>Type de décompte</strong></label>
                      <b-form-radio-group id="type_decompte" v-model="type_decompte">
                        <b-form-radio value="dcinval">Tous</b-form-radio>
                        <b-form-radio value="dc">Décès</b-form-radio>
                        <b-form-radio value="inval">Invalidité</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="4" md="4">
                    <b-form-group >
                      <label for="id_pp"><strong>N°Identifiant NSI</strong></label>
                      <b-form-input type="text" id="id_pp" v-model="id_pp" :class="{hasError: errors.id_pp !== ''}"></b-form-input>
                      <span class="field-error">{{ errors.id_pp }}</span>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4" md="4">
                    <b-form-group >
                      <label for="num_dossier"><strong>N° Dossier</strong></label>
                      <b-form-input type="text" id="num_dossier" v-model="num_dossier" :class="{hasError: errors.num_dossier !== ''}"></b-form-input>
                      <span class="field-error">{{ errors.num_dossier }}</span>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4" md="4">
                    <b-form-group >
                      <label for="num_decompte"><strong>N° Décompte</strong></label>
                      <b-form-input type="text" id="num_decompte" v-model="num_decompte" :class="{hasError: errors.num_decompte !== ''}"></b-form-input>
                      <span class="field-error">{{ errors.num_decompte }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="4" md="4">
                    <b-form-group >
                      <label for="nir"><strong>N° Sécurité Sociale</strong></label>
                      <b-form-input type="text" id="nir" v-model="nir" :class="{hasError: errors.nir !== ''}"></b-form-input>
                      <span class="field-error">{{ errors.nir }}</span>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4" md="4">
                    <b-form-group >
                      <label for="nom"><strong>Nom</strong></label>
                      <b-form-input type="text" id="nom" v-model="nom" :class="{hasError: errors.nom !== ''}"></b-form-input>
                      <span class="field-error">{{ errors.nom }}</span>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4" md="4">
                    <b-form-group >
                      <label for="prenom"><strong>Prénom</strong></label>
                      <b-form-input type="text" id="prenom" v-model="prenom" :class="{hasError: errors.prenom !== ''}"></b-form-input>
                      <span class="field-error">{{ errors.prenom }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="2">
                    <b-form-group>
                      <label for="date_du"><strong>Période du</strong></label>
                      <b-form-input type="date" id="date_du" v-model="date_du" :class="{hasError: errors.date_du !== ''}"></b-form-input>
                      <span class="field-error">{{ errors.date_du }}</span>
                    </b-form-group>
                  </b-col>
                  <b-col sm="2">
                    <b-form-group>
                      <label for="date_au"><strong>Au</strong></label>
                      <b-form-input type="date" id="date_au" v-model="date_au" :class="{hasError: errors.date_au !== ''}"></b-form-input>
                      <span class="field-error">{{ errors.date_au }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>
                <div slot="footer">
                  <b-button type="button" @click.prevent="clearForm()" size="md" variant="secondary" class="mr-1">
                    <i class="fa fa-eraser"></i> Effacer
                  </b-button>
                  <b-button type="enter" @click.prevent="search()" size="md" variant="primary">
                    <i class="fa fa-search"></i> Rechercher
                  </b-button>
                </div>
              </b-form>
            </b-card>
          </b-card-body>
        </b-collapse>
      </b-card>
    </transition>

      <b-card no-body>
        <b-card-header>
          <i class="fa fa-list mr-2"></i>
          <strong>Liste des décomptes</strong>
        </b-card-header>
        <b-card-body>
          <decompte-table :tableEntry="tableParam" ref="decompte_table"></decompte-table>
        </b-card-body>
      </b-card>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../../utils/auth'
import DecompteTable from '../../components/DecompteTable'
import {fr} from 'vuejs-datepicker/dist/locale'

export default {
  components: { DecompteTable },
  data() {
    return {
      id_pp: "",
      num_dossier: "",
      num_decompte: "",
      nir: "",
      nom: "",
      prenom: "",
      type_decompte: "dcinval",
      date_du: "",
      date_au: "",
      noSearch: "noSearch",
      errors: { date_au: '', date_du: '', id_pp: '', num_dossier: '', num_decompte: '', nir: '', nom: '', prenom: '' },
      fr: fr,
      DatePickerFormat: 'dd/MM/yyyy'
    };
  },
  created() { 
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
  },
  computed: {
    tableParam: {
      get() {
        let request = {};

        request.type_decompte = this.type_decompte;
        request.num_decompte = this.num_decompte.replace(/ /g, "")
        this.num_decompte = request.num_decompte
        request.id_pp = this.id_pp.replace(/ /g, "")
        this.id_pp = request.id_pp
        request.num_dossier = this.num_dossier.replace(/ /g, "")
        this.num_dossier = request.num_dossier
        request.nir = this.nir.replace(/ /g, "")
        this.nir = request.nir
        request.nom = this.nom.replace(/ /g, "")
        this.nom = request.nom
        request.prenom = this.prenom.replace(/ /g, "")
        this.prenom = request.prenom
        request.date_du = this.date_du;
        request.date_au = this.date_au;
        request.noSearch = this.noSearch;
        
        return request;
      }
    },
  },
  methods: {
    search() {
      if (this.validateData()) {
        this.$store.commit("IS_LOADING", true)
        this.noSearch = ""
        this.$refs.decompte_table.$refs.table.refresh()
      }
    },
    validateData() {
      this.clearErrors()
      let regNumeric = this.$store.getters.getRegNumeric
      let valid = true

      let id_pp = this.id_pp.replace(/ /g, "")
      if (id_pp !== '') {
        if (!regNumeric.test(id_pp)) {
          this.errors.id_pp = 'Un N°Identifiant NSI ne doit contenir que des chiffres'
          valid = false
        }
        else if (id_pp.length > 9 || id_pp.length < 9) {
          this.errors.id_pp = 'Un N°Identifiant NSI doit contenir exactement 9 chiffres'
          valid = false
        }
      }

      let num_dossier = this.num_dossier.replace(/ /g, "")
      if (num_dossier !== '') {
        if (!regNumeric.test(num_dossier)) {
          this.errors.num_dossier = 'Un N° Dossier ne doit contenir que des chiffres'
          valid = false
        }
      }

      let nir = this.nir.replace(/ /g, "")
      if (nir !== '') {
        if (!regNumeric.test(nir)) {
          this.errors.nir = 'Un N° de Sécurité Sociale ne doit contenir que des chiffres'
          valid = false
        }
        else if (nir.length > 13 || nir.length < 13) {
          this.errors.nir = 'Un N° de Sécurité Sociale doit contenir exactement 13 chiffres'
          valid = false
        }
      }

      let num_decompte = this.num_decompte.replace(/ /g, "")
      if (num_decompte !== '' && !regNumeric.test(num_decompte)) {
        this.errors.num_decompte = 'Un N° Dossier ne doit contenir que des chiffres'
        valid = false
      }
      return valid;
    },
    clearErrors() {
      this.errors.date_du = '' 
      this.errors.date_au = ''
      this.errors.id_pp = ''
      this.errors.num_dossier = ''
      this.errors.num_decompte = ''
      this.errors.nir = ''
    },
    clearForm() {
      this.date_du = '' 
      this.date_au = ''
      this.id_pp = ''
      this.num_dossier = ''
      this.num_decompte = ''
      this.nir = ''
      this.nom = ''
      this.prenom = ''
    }
  }
};
</script>

<style>
.collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
}

#list-decomptes .wrapper {
    text-align: center;
}

#list-decomptes .VueTables__table thead tr th:first-child {
  width: 8%;
}
#list-decomptes .VueTables__table thead tr th:nth-child(2) {
  width: 6%;
}
#list-decomptes .VueTables__table thead tr th:nth-child(3) {
  width: 8%;
}
#list-decomptes .VueTables__table thead tr th:nth-child(4) {
  width: 8%;
}
#list-decomptes .VueTables__table thead tr th:nth-child(5) {
  width: 8%;
}
#list-decomptes .VueTables__table thead tr th:nth-child(6) {
  width: 8%;
}
#list-decomptes .VueTables__table thead tr th:nth-child(7) {
  width: 10%;
}
#list-decomptes .VueTables__table thead tr th:nth-child(8) {
  width: 10%;
}
#list-decomptes .VueTables__table thead tr th:nth-child(9) {
  width: 6%;
}
#list-decomptes .VueTables__table thead tr th:nth-child(10) {
  width: 6%;
}
#list-decomptes .VueTables__table thead tr th:nth-child(11) {
  width: 2%;
}
</style>

